import { useEffect, useState, useRef } from "react";
import { useResourceContext } from "@/layouts/ResourceContext";
import { Table, Badge, Flex, Typography } from "antd";
import { useTable } from "@refinedev/antd";
import { RefreshButton } from "@/components/common/RefreshButton";
import { useInvalidate } from "@refinedev/core";
import { useFormatter } from "@/hooks/useFormatter";

export const EventsPanel = ({type}) => {
  const { state, dispatch } = useResourceContext();
  const [ selectedInstance ] = state.selectedResources;
  
  return selectedInstance?<EventsTab key={selectedInstance.id} selectedId={selectedInstance.id} type={type}/>:null;
}
const EventsTab = ({type, selectedId}) => {
  const { formatDateTime } = useFormatter();
  const invalidate = useInvalidate();
  const totalRef = useRef(0);
  const { tableProps} = useTable({resource:"events",
    syncWithLocation: false,
    pagination:{current:1, pageSize:10},
    sorters: {initial: []},
    meta:{id:selectedId, type:type, _total_:totalRef.current}});
  const { Title } = Typography;
  totalRef.current = tableProps.pagination.total || totalRef.current;
  let title = `Events (${totalRef.current})`;
  const columns = [    
    {
      title: '',
      dataIndex: 'type',
      key: 'type',
      width: 30,
      render: (value) => value == "Warning" && <Badge status="warning"/>
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },   
    {
      title: 'Reason',
      dataIndex: 'reason',
      key: 'reason',
      sorter:{}
    },
    {
      title: 'Message',
      dataIndex: 'message',
      key: 'message'
    },   
    {
      title: 'Source',
      dataIndex: 'source',
      key: 'source'
    },   
    {
      title: 'Object',
      dataIndex: 'object',
      key: 'object'
    },   
    {
      title: 'Count',
      dataIndex: 'count',
      key: 'count'
    },   
    {
      title: 'First Seen',
      dataIndex: 'firstSeen',
      key: 'firstSeen',
      render: (value) => formatDateTime(value),
      sorter:{}
    },   
    {
      title: 'Last Seen',
      dataIndex: 'lastSeen',
      key: 'lastSeen',
      render: (value) => formatDateTime(value),
      sorter:{}
    }
  ];
  return (
    <div>
      <Flex justify="space-between" align="center">
        <Title level={5} >{title}</Title>
        <RefreshButton onClick={() => {
        invalidate({
          resource: "events",
          invalidates: ["list"],
        });
      }}/>
      </Flex> 
      <div style={{paddingTop:"10px"}}>    
      <Table {...tableProps} rowKey="id" size="small" columns= {columns} />
      </div>
      </div>);
/*  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
 
  
  useEffect(() => {
    const getEvents = async ( type, id ) => {
        setIsLoading(true);
        const response = await getEventList(type, id);
        setIsLoading(false);
        if (response.status === "OK") {
          let count = response.value.listMeta.totalItems;
          setTotalCount(count);
          if(response.value.events){
            let evts = [];
            let idx = 0;
            response.value.events.forEach((item) => {
              let evt = {type: item.type, name: item.objectMeta.name, message:item.message, reason:item.reason, count:item.count};
              evt.source = `${item.sourceHost} ${item.sourceComponent}`;
              evt.object = `${item.objectKind}/${item.objectNamespace}`;
              evt.firstSeen = item.firstSeen;
              evt.lastSeen = item.lastSeen;
              evt.key = idx++;
              evts.push(evt);
            });
            setEvents(evts);
          } else {
            setEvents([]);
          }
          
        } else {
          console.log("Failed to get events:" + response);
        }
    };

    getEvents(type, id);
  }, [id]);  
  const columns = [    
    {
      title: '',
      dataIndex: 'type',
      key: 'type',
      width: 30,
      render: (value) => value == "Warning" && <Badge status="warning"/>
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },   
    {
      title: 'Reason',
      dataIndex: 'reason',
      key: 'reason'
    },
    {
      title: 'Message',
      dataIndex: 'message',
      key: 'message'
    },   
    {
      title: 'Source',
      dataIndex: 'source',
      key: 'source'
    },   
    {
      title: 'Object',
      dataIndex: 'object',
      key: 'object'
    },   
    {
      title: 'Count',
      dataIndex: 'count',
      key: 'count'
    },   
    {
      title: 'First Seen',
      dataIndex: 'firstSeen',
      key: 'firstSeen',
      render: (value) => formatDateTime(value)
    },   
    {
      title: 'Last Seen',
      dataIndex: 'lastSeen',
      key: 'lastSeen',
      render: (value) => formatDateTime(value)
    }
  ];

  const = onChange

  return (<Table size="small" dataSource={events} columns= {columns} loading={isLoading} onChange={}
                 pagination={{defaultCurrent:1, total:totalCount, position:"bottomRight"}}/>);
                 */
}